













import {Component, Prop, Vue} from 'vue-property-decorator';
import PaymentItem from './paymentItem.vue';
import CollapseBox from '@/components/collapseBox/collapseBox.vue';
import { classifyDataByKey, generateClassifications, ICollapseInfo, mergeClassifiedData } from '@/components/collapseBox/collapseBoxUtils';
import { AccountModule } from '@/store/modules/account';

type IPaymentInfo = IPayment.IResponse.IPaymentInfo;

@Component({
  components: {
    PaymentItem,
    CollapseBox,
  },
})
export default class PaymentList extends Vue {
  @Prop({default: ''}) private activeId!: string;
  @Prop({default: false}) private spinning!: boolean;
  @Prop({required: true, default: () => []}) private data!: IPaymentInfo[];

  private viewDetail(payment: IPaymentInfo) {
    this.$emit('click', payment);
  }
  get classifyDataByAccount() {
    // 根据账号对应的projects 生成 分类数据
    return generateClassifications(AccountModule.projects, 'id', 'name');
  }
  get dataByProjectCategory(): ICollapseInfo[] {
    const classifyData = classifyDataByKey(this.data, 'projectId', 'projectName');
    return mergeClassifiedData(this.classifyDataByAccount, classifyData);
  }
}
